import AuthService from "../login/auth.service";
import { comprobantes,cuentas } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class MovimientoCuentaService {
    async obtenerMovimientoCuenta(data) {

        var config = {
            method: "post",
            url: comprobantes + "comprobantes/v2/movimientoCuenta",
            data: data,
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken(),
            },
        };
        return await axios(config);
    }
    async obtenerDetalleTransferencia(idMovimiento, tipoTransferencia, tipoMovimiento) {
        var data = JSON.stringify({
            idMovimiento:idMovimiento,
            tipoTransferencia : tipoTransferencia,
            tipoMovimiento : tipoMovimiento
           
          });
        var config = {
            method: "post",
            url: cuentas + "movimiento/detalle-movimiento",
            data: data,
          
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken(),
            },
        };
        return await axios(config);
    }

}
export default new MovimientoCuentaService();
